import styled from "styled-components";
import { colors } from "../../../../../../shared/styled/varibles";

export const VideoCardSC = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 0;
    gap: 0.5rem;
    width: 100%;
`;

export const NumberSC = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
`;

export const ContentSC = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 0;
    gap: 1.6rem;
    width: 100%;
`;

export const VideoPreviewSC = styled.div<{ imgUrl: string }>`
    width: calc((100% - 1.6rem)/2);
    height: 100%;
    background: ${({ imgUrl }) => (imgUrl ? `url(${imgUrl});` : "")} 
    border-radius: 12px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    min-height: 432px;
`;

export const TextContentSC = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    padding: 1.6rem 2rem 1.6rem 2.4rem;
    gap: 1rem;
    border: 1px solid ${colors.bluishGray};
    border-radius: 1.2rem;
    width: calc((100% - 1.6rem) / 2);
    min-height: 432px;
`;

export const TextSC = styled.div`
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 1.6rem;
    line-height: 150%;
    color: ${colors.textColor};
    max-height: 33.5rem;
    overflow: auto;
`;
